import { errorMessage } from "./ConfirmAlertUtil";

export const handleFileSizeException = () => {
    errorMessage("Aceito apenas arquivos até 10Mb.");
}